<template>
  <div class="ouisrael-games">
    <div class="games__group">
      <div data-amount="179" class="amount-row">
        <input
          id="179_0"
          type="radio"
          class="amount"
          @click="selectedAmount = 179"
          :checked="selectedAmount == 179"
        />
        <label for="179_0">
          <span class="label-description">משחק קופסה</span>
          <img
            src="https://res.cloudinary.com/orthodox-union/image/upload/c_scale,f_auto,q_auto,w_200/v1662455941/ouisrael/game%20lp/game2.png"
          />

          <div class="money_format label-amount">₪179</div>
        </label>
      </div>

      <div data-amount="2800" class="amount-row">
        <input
          id="2800_0"
          type="radio"
          class="amount"
          @click="selectedAmount = 2800"
          :checked="selectedAmount == 2800"
        />
        <label for="2800_0">
          <span class="label-description">משחק רצפה</span>
          <img
            src="https://res.cloudinary.com/orthodox-union/image/upload/c_scale,f_auto,q_auto,w_200/v1662455941/ouisrael/game%20lp/game1.png"
          />
          <div class="money_format label-amount">₪2,800</div>
        </label>
      </div>
    </div>
    <ErrorLabel field="amount" />
    <div class="lp__ganme__sub" v-if="selectedAmount == 179">
      הנחה ברכישת 10 משחקים ומעלה - 149 ש"ח למשחק
    </div>

    <div class="amount-row tickets-num" v-if="selectedAmount == 179">
      <FormSection title="כמות" class="">
        <div class="label__qty">
          <input
            id="smallGameQnt"
            type="number"
            min="1"
            name="smallGameQnt"
            placeholder="כמות"
            v-model="smallGameQnt"
            @change="customQnt = true"
          />
        </div>
      </FormSection>
    </div>
    <div class="amount-row tickets-num" v-if="selectedAmount == 2800">
      <FormSection title="כמות" class="">
        <div class="label__qty">
          <input
            id="bigGameQnt"
            type="number"
            min="1"
            name="bigGameQnt"
            placeholder="כמות"
            v-model="bigGameQnt"
            @change="customBigQnt = true"
          />
        </div>
      </FormSection>
    </div>

    <div class="delivery__section" v-if="selectedAmount > 1">
      <FormSection title="בחר סוג משלוח" class="">
        <div class="delivery__fee">
          <div class="radio-part">
            <input
              id="type_attending"
              name="Attending"
              type="radio"
              :checked="deliveryFee == 25"
              @click="deliveryFee = 25"
            />
            <FormLabel for="type_attending" class="forceShow">
              <span>₪25.00</span>
              שליח עד הבית (לא לחו״ל) - עד 10 ימי עסקים
            </FormLabel>
          </div>
          <div class="radio-part">
            <input
              name="Attending"
              id="type_noattending"
              type="radio"
              :checked="deliveryFee == 0"
              @click="deliveryFee = 0"
            />
            <FormLabel for="type_noattending" class="forceShow">
              <span>₪0.00</span>
              איסוף מסניף - נעדכן לאיסוף עד 10 ימי עסקים
            </FormLabel>
          </div>
          <ErrorLabel field="custom.deliveryFee" />
        </div>
      </FormSection>
    </div>
    <div class="summery__section" v-if="selectedAmount > 1">
      <FormSection title="">
        <ul class="summary__total">
          <li>
            משחק נבחר: <strong>{{ getValue("custom.gameType") }}</strong>
          </li>
          <li>
            כמוּת:
            <strong>{{
              getValue("custom.bigGameQnt")
                ? getValue("custom.bigGameQnt")
                : getValue("custom.smallGameQnt")
            }}</strong>
          </li>
          <li>
            סכום סופי: <strong>₪{{ getValue("amount") }}</strong>
          </li>
          <li>
            דמי משלוח:
            <strong
              >₪{{ deliveryFee == 25 ? "25 - שליח עד הבית" : "0 - איסוף מסניף" }}</strong
            >
          </li>
        </ul>
      </FormSection>
    </div>
  </div>
</template>
<script lang="ts">
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  components: {},
  setup() {
    const { setValue, form, settings, getValue } = usePaymentForm();

    const selectedAmount = ref();
    const totalAmount = ref(form.value.amount);
    const smallGameQnt = ref();
    const bigGameQnt = ref();
    const customAmount = ref(form.value.amount);
    const customSelected = ref(false);
    const customQnt = ref(false);
    const customBigQnt = ref(false);
    const deliveryFee = ref(25);

    setValue("custom.deliveryFee", "25");

    watch(selectedAmount, (selectedAmount) => {
      if (selectedAmount) {
        customSelected.value = false;
        customAmount.value = null;
        setValue("amount", "" + (parseInt(selectedAmount) + deliveryFee.value));

        if (selectedAmount == 2800) {
          setValue("custom.gameType", "משחק רצפה");
          setValue("custom.smallGameQnt", null);
          setValue("custom.bigGameQnt", "" + 1);
        } else {
          setValue("custom.gameType", "משחק קופסה");
          setValue("custom.bigGameQnt", null);
          setValue("custom.smallGameQnt", "" + 1);
        }
      }
    });

    watch(customQnt, () => {
      customQnt.value = false;
      if (smallGameQnt) {
        if (smallGameQnt.value > 9) {
          setValue(
            "amount",
            "" + (149 * parseInt(smallGameQnt.value) + deliveryFee.value)
          );
          setValue("custom.smallGameQnt", smallGameQnt.value);
          setValue("custom.bigGameQnt", null);
        } else {
          setValue(
            "amount",
            "" + (179 * parseInt(smallGameQnt.value) + deliveryFee.value)
          );
          setValue("custom.smallGameQnt", smallGameQnt.value);
          setValue("custom.bigGameQnt", null);
        }
      }
    });

    watch(customBigQnt, () => {
      customBigQnt.value = false;
      if (bigGameQnt) {
        setValue("amount", "" + (2800 * parseInt(bigGameQnt.value) + deliveryFee.value));
        setValue("custom.bigGameQnt", bigGameQnt.value);
        setValue("custom.smallGameQnt", null);
      }
    });

    watch(deliveryFee, () => {
      if (getValue("amount")) {
        const currentAmount = getValue("amount");
        setValue("custom.deliveryFee", "" + deliveryFee.value);
        if (deliveryFee.value == 25 && currentAmount !== null) {
          setValue("amount", "" + (parseInt(currentAmount) + 25));
        }
        if (deliveryFee.value == 0 && currentAmount !== null) {
          setValue("amount", "" + (parseInt(currentAmount) - 25));
        }
      }
    });

    function clearOutSelectedValue() {
      totalAmount.value = null;
      selectedAmount.value = null;
      deliveryFee.value = 0;
      setValue("amount", null);
    }

    return {
      form,
      currency: computed(() => form.value.currency),
      getValue,
      setValue,
      selectedAmount,
      customAmount,
      smallGameQnt,
      bigGameQnt,
      clearOutSelectedValue,
      customSelected,
      customQnt,
      customBigQnt,
      deliveryFee,
    };
  },
});
</script>
<style scoped lang="scss">
.games__group {
  display: flex;
  justify-content: space-between;
  .amount-row {
    min-width: 48%;
    max-width: 48%;
    margin-bottom: 15px;
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    border: 1px solid #ddd;
    width: 100%;
    &:hover {
      label {
        background: #ffffff;
      }
    }
    input {
      height: 0;
      top: 20px;
      position: absolute;
      left: 20px;
      z-index: -1;
      visibility: hidden;
    }
    label {
      font-weight: 700;
      color: #575757;
      width: 100%;
      background: #f7f7f7;
      border-radius: 4px;
      cursor: pointer;
      height: 100%;
      margin-bottom: 0px;
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
    }
    .label-amount {
      font-weight: 700;
      padding: 13px 10px;
      font-size: 15px !important;
      align-items: center;
      width: 100%;
      justify-content: center;
      background: #f7f7f7;
      display: flex;
      color: black;
      margin-top: auto;
      justify-content: center;
    }
  }
  .label-description {
    display: block;
    font-size: 20px;
    width: 100%;
    padding: 9px 0px;
    text-align: center;
  }
}

.amount-row.tickets-num {
}
.lp__ganme__sub {
  font-size: 14px;
  font-style: italic;
  line-height: 18px;
  padding: 0px 7px 7px;
}
.label__qty {
  max-width: 100px;
}

.games__group input[type="radio"]:checked + label {
  background: #fbad18 !important;
}
ul.summary__total {
  padding: 8px 7px;
  margin: 16px 0px 0px;
  background: #f7f7f7;
  border-radius: 5px;
}

.delivery__fee {
  grid-gap: 2%;
  gap: 2%;
  justify-content: flex-start;
  margin: 0 0 5px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .radio-part {
    min-width: 100%;
    flex: 1;
    padding-right: 10px;
    padding-left: 0;
    max-width: 100%;
    margin-bottom: 10px;
    padding: 0 5px;
    line-height: 1;

    @media (min-width: 720px) {
      min-width: 48%;
      max-width: 48%;
    }
    input {
      height: 0;
      top: 20px;
      position: relative;
      left: 20px;
      z-index: -1;
      visibility: hidden;
    }
    label {
      font-weight: 500;
      display: flex !important;
      line-height: normal;
      flex-flow: row-reverse;
      padding: 15px;
      background: #fff;
      border: 1px solid #ddd;
      font-weight: 700;
      color: #575757;
      width: 100%;
      text-align: right;
      border-radius: 4px;
      cursor: pointer;
      margin-top: -15px;
      gap: 9px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
      }
    }

    input[type="radio"]:checked + label {
      background: #fbad18 !important;
      color: black;
    }
  }
}

.summery__section {
  ::v-deep hr {
    display: none;
  }
}
</style>
